import { Modal as ModalModule } from 'common';
import { ManageCarrier } from 'common/src/code/carrier/ManageCarrier.component';
import React, { useContext } from 'react';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

const AddCarrierModal = ({ data: { selectedLocations }, modalId }) => {
	const { showMessage, closeModal } = useContext(ModalContext);

	const completionCallback = (success, carrier, locationsLength) => {
		if (success) {
			showMessage({
				data: {
					title: `Bulk Update ${locationsLength} Locations`,
					description: `<p>We have initiated the process of adding a carrier to your chosen locations. You will receive an email notification when this process is completed. </p>

					<p>Depending on the number of locations, this process can take up to one business day. But if it ends early due to an error, we will notify you right away.</p>`,
					primaryButtonType: ModalButtonActionType.Ok,
					primaryButtonText: 'Ok',
				},
			});
		}
	};

	const displayNoEligibleCarriersMessage = () => {
		showMessage({
			data: {
				title: 'Unable to Add Carrier',
				description:
					'The selected locations are not eligible to add any more carriers.',
				primaryButtonType: ModalButtonActionType.Ok,
				primaryButtonText: 'Ok',
			},
			closeCallback: async () => {
				closeModal(modalId);
			},
		});
	};

	return (
		<Modal
			modalId={modalId}
			className="account-locations addCarrier-modal"
			header={`Bulk Update ${selectedLocations.length} Locations`}
			supressPrimaryButton
			secondaryButton={{
				type: ModalButtonActionType.Cancel,
				text: 'Exit',
			}}
			size="small"
		>
			<ManageCarrier
				enterpriseLocations={selectedLocations}
				addCarrierCallback={completionCallback}
				noEligibleCarriersCallback={displayNoEligibleCarriersMessage}
			/>
		</Modal>
	);
};

export default AddCarrierModal;
